import cn from 'classnames'
import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'
import { LYSCard, LYSTypography } from '@core/components/Primitives'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import style from './index.module.less'
import { RenderProp, Slot, template } from '@core/utils/templates'

export interface ProductInformationProps {
  className: string
}

interface ProductInformationSlots {
  title?: RenderProp<void>
  description?: RenderProp<void>
}

const ProductInformation = template<
  ProductInformationProps,
  ProductInformationSlots
>(({ className, slots }) => {
  const { t } = useTranslation()
  const { product } = useProductDetailContext() || {}
  if (!product || !product.description) {
    return null
  }

  return (
    <LYSCard bordered={false} className={cn(style.descriptionBox, className)}>
      <Slot render={slots?.title}>
        <LYSTypography.Title visualAppearance={'h4'} level={2}>
          {t('productDetail.description')}
        </LYSTypography.Title>
      </Slot>
      <Slot render={slots?.description}>
        <ReactMarkdown plugins={[breaks]} className={style.description}>
          {product.description}
        </ReactMarkdown>
      </Slot>
    </LYSCard>
  )
})

export default ProductInformation
